import React from "react";

import Typography from "@mui/material/Typography";
import ButtonBase from "@mui/material/ButtonBase";

import { ReactComponent as ExpandIcon } from "assets/images/expand-icon.svg";

import { styles } from "./styles";

interface FilterButtonProps {
  id?: string;
  label: string;
  active: boolean;
  popover?: boolean;
  children?: React.ReactNode;
  handleClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

const FilterButton = ({
  id,
  label,
  active,
  popover,
  children,
  handleClick,
}: FilterButtonProps) => {
  const filterId = active ? `${id}-popover` : undefined;

  return (
    <ButtonBase
      data-testid={`filter-btn-${id}`}
      aria-describedby={filterId}
      onClick={handleClick}
      sx={[styles.button, active && styles.buttonOpen]}
    >
      {children}
      <Typography sx={{ whiteSpace: "nowrap" }} variant="subtitle2">
        {label}
      </Typography>
      {popover && (
        <ExpandIcon
          style={{
            transition: "transform 0.3s",
            transform: active ? "rotate(180deg)" : "rotate(0deg)",
          }}
        />
      )}
    </ButtonBase>
  );
};

export default FilterButton;
